export function validateId(id) {
    const re = /^[0-9]+$/;
    return re.test(String(id));
}

export function validateEmail(email) {
    if (!email) return false;
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).trim().toLowerCase());
}

export function validatePhone(phone) {
    if (!phone) return false;
    // Permite formato internacional opcional + seguido de 7 a 15 dígitos, ignorando espacios/guiones
    const cleaned = String(phone).replace(/[\s-]/g, '');
    const re = /^\+?[0-9]{7,15}$/;
    return re.test(cleaned);
}

export function validateDocumentNumber(doc, typeId) {
    if (!doc) return { valid: false, message: 'El documento es requerido' };
    const cleaned = String(doc).trim();
    const type = parseInt(typeId, 10);

    // 1: Cédula de ciudadanía, 2/6: NIT, 3: Tarjeta de identidad
    if ([1, 2, 6, 3].includes(type)) {
        if (!/^\d+$/.test(cleaned)) {
            return { valid: false, message: 'Debe contener únicamente números' };
        }
        if (cleaned.length < 5 || cleaned.length > 15) {
            return { valid: false, message: 'Debe tener entre 5 y 15 dígitos' };
        }
    } else {
        // Pasaporte, Cédula de extranjería, etc.
        if (!/^[a-zA-Z0-9-]{3,20}$/.test(cleaned)) {
            return { valid: false, message: 'Formato de documento inválido (3-20 caracteres alfanuméricos)' };
        }
    }

    return { valid: true };
}

export function validatePostalCode(code) {
    if (!code) return false;
    return /^\d{4,10}$/.test(String(code).trim());
}

export function validateAddress(address) {
    if (!address) return false;
    return String(address).trim().length >= 5;
}

export function getPasswordStrength(password) {
    if (!password) return { score: 0, label: '', class: '' };
    if (password.length < 6) return { score: 1, label: 'Muy Débil', class: 'weak' };

    let score = 0;
    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;

    if (score <= 1) return { score: 1, label: 'Débil', class: 'weak' };
    if (score <= 2) return { score: 2, label: 'Media', class: 'medium' };
    return { score: 3, label: 'Fuerte', class: 'strong' };
}

